// components/CommonLoader.tsx
import { useLoaderStore } from "@/store/useLoaderStore";

const CommonLoader = () => {
  const loading = useLoaderStore((state) => state.loading);

  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-white border-t-transparent" />
    </div>
  );
};

export default CommonLoader;
